import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { MDBBtn } from "mdbreact";
import { adminActions } from "../../../redux/actions";
import MainApp from "../../layouts/MainApp";
import { Beat } from "../../../redux/reducers/spinner";

export default function CreateKYCTier() {
  const dispatch = useDispatch();
  const history = useHistory();

  const creating = useSelector((state) => state.admin.creating);
  const [submitted, setSubmitted] = useState(false);
  const [data, setData] = useState({
    title: "",
    daily_limit: "",
    monthly_limit: "",
    limit_currency: "NGN",
  });


  const { title, daily_limit, monthly_limit } = data;

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setData({ ...data, [name]: value });
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    if (title && daily_limit && monthly_limit) {
      try {
        const response = await dispatch(
          adminActions.storeHumanVerificationLevel(data)
        );
        if (response?.status === "success") {
          history.goBack();
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  return (
    <MainApp>
      <div className="main-content-padding">
        <div className="main-content">
          <div
            className="mx-auto bg-white w-100 px-4"
            style={{
              marginTop: "2.5rem",
              paddingBottom: "2rem",
              maxWidth: "630px",
              marginLeft: "2.5rem",
              border: "1px solid #E5E7EB",
            }}
          >
            {" "}
            <div className="border-b-2 py-4 mb-6">
              <p className=" text-base font-medium text-gray-800 dark:text-white flex justify-center ">
                Create New KYC Tier
              </p>
            </div>
            <form className="pb-8">
              <div className=" sm:px-10">
                {/* new form starts */}
                <div
                  className={
                    "form-group mb-4" + (submitted && title ? " has-error" : "")
                  }
                >
                  <label htmlFor="title">Enter Tier Title</label>
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    placeholder={"Enter tier title"}
                    onChange={handleChange}
                  />
                  {submitted && !title && (
                    <div className="help-block">Tier title is required</div>
                  )}
                </div>

                <div
                  className={
                    "form-group mb-4" +
                    (submitted && daily_limit ? " has-error" : "")
                  }
                >
                  <label htmlFor="daily_limit">Tier Daily Limit*</label>
                  <input
                    type="number"
                    autoComplete="off"
                    className="form-control"
                    name="daily_limit"
                    onChange={handleChange}
                  />
                  {submitted && !daily_limit && (
                    <div className="help-block">
                      Tier Daily Limit is required
                    </div>
                  )}
                </div>

                <div
                  className={
                    "form-group mb-4" +
                    (submitted && monthly_limit ? " has-error" : "")
                  }
                >
                  <label htmlFor="monthly_limit">Tier Monthly Limit</label>
                  <input
                    type="number"
                    id="monthly_limit"
                    autoComplete="off"
                    className="form-control"
                    name="monthly_limit"
                    onChange={handleChange}
                  />
                  {submitted && !monthly_limit && (
                    <div className="help-block">
                      Tier Monthly Limit is required
                    </div>
                  )}
                </div>
              </div>
            </form>
            <MDBBtn
              color="primary"
              type="button"
              onClick={handleSubmit}
              className={"w-[150px] sm:mt-10 rounded-sm "}
            >
              {creating ? <Beat /> : "Create Tier"}
            </MDBBtn>
          </div>
        </div>
      </div>
    </MainApp>
  );
}
